var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":_vm.showPopup}},[_vm._v("展开")]),_c('van-popup',{style:({ height: '30%' }),attrs:{"closeable":"","position":"bottom"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("内容 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }